export const capitalizeFirstLetter = (string: string) => {
  if (!string) {
    return string;
  }

  const firstChar = string.charAt(0);
  const upperFirstChar = firstChar.toLocaleUpperCase();

  // Return early if character doesn't change (e.g., Arabic, Hebrew, numbers, symbols)
  if (firstChar === upperFirstChar) {
    return string;
  }

  return upperFirstChar + string.slice(1);
};
